import { apiRequest } from "../lib/apiClient";
import type { SupplierCreate, SupplierOut } from "./types";

export async function listSuppliers(accessToken: string): Promise<SupplierOut[]> {
  return apiRequest<SupplierOut[]>("/suppliers", { accessToken });
}

export async function createSupplier(accessToken: string, body: SupplierCreate): Promise<SupplierOut> {
  return apiRequest<SupplierOut>("/suppliers", { method: "POST", accessToken, body });
}
